import { CHCHeader } from "./CHCHeader";
import { CHCContent } from "./CHCContent";
import { IRESTClient, RESTClientImpl } from "../services/RESTClient";
import logo from '../../chc-logo.svg';
import { useEffect, useState } from "react";
import { RestClientUT } from "../services/RESTClientUT";

export interface CHCLayoutProps {
    client: IRESTClient
}

export const CHCLayout = (props: CHCLayoutProps) => {
    const {client} = props;
    const [loggedIn, setLoggedIn] = useState(false);
    const [unauthorized, setUnauthorized] = useState(true);

    useEffect(() => {

        //** This method passes the given auth code to the rest clients Authenticate method to fetch open id tokens from the api. */
        const GetUserData = async (authCode: string) => {
            await client.Authenticate(authCode)
            .then(() => {
                if (RestClientUT.GetIdToken() || RESTClientImpl.GetIdToken()) {
                    window.history.replaceState({}, document.title, "/")
                    setUnauthorized(false);
                    setLoggedIn(true);
                }
            });
        }

        if(loggedIn)
            return;

        let currentUrl = window.location.href;
        if (process.env.NODE_ENV==='development')
            currentUrl = process.env.REACT_APP_REDIRECT!.concat('?code=123-345-123-321-332211');
    
        if (currentUrl.includes(process.env.REACT_APP_REDIRECT!.concat('?code='))) {
            let splitUrl = currentUrl.split('?code=');
            const authCode = splitUrl[splitUrl.length - 1];
            if(authCode)
                GetUserData(authCode);
        }
 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[loggedIn, unauthorized]);

    return (
        <div style={{display:'flex', flexDirection:'column', background:'rgba(0, 0, 0, 0.03', minHeight:'100vh'}}>
            {/* HEADER ROW */}
            <div style={{display:'flex', flexDirection:'row', boxShadow: '4px 7px 9px rgba(0, 0, 0, 0.2)'}}>
                <CHCHeader src={logo}/>
            </div>

            {/* CONTENT ROW */}
            <div style={{display:'flex', flexDirection:'row', margin:'.2%', flexWrap:'wrap'}}>
                <div style={{display:'flex', flexDirection:'column', margin:'.2%', flex:'10 1'}}>
                    {loggedIn && <CHCContent client={client}/>}
                </div>
                
            </div>
        </div>);
}
